<template>
  <div class="item-box-content-table" style="margin-bottom:0;">
    <div class="title-font-style">
      <span>物流信息</span>
    </div>
    <el-form style="padding:20px 30px 0px 30px">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="配送方式：" label-width="70px" v-show="$route.query.sendType !=='直发'">
            <el-select
              v-model="params.logisticType"
              value-key="id"
              @change="logisticTypeChange(params.logisticType)"
            >
              <el-option
                v-for="(item, index) in logisticTypeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="配送方式："
            label-width="70px"
            v-show="$route.query.sendType ==='直发'"
          >{{"物流配送"}}</el-form-item>
        </el-col>
        <el-col :span="8" v-if="params.logisticType === '快递配送'&& $route.query.sendType !=='直发'">
          <el-form-item label="快递公司：" label-width="70px">
            <el-input v-model="params.expressCompany"></el-input>
          </el-form-item>
        </el-col>

        <el-col
          :span="8"
          v-if="
           (params.logisticType === '物流配送' ||params.logisticType === undefined)&& $route.query.sendType !=='直发'
          "
        >
          <el-form-item label="物流公司：" label-width="70px">
            <el-input v-model="params.logisticCompany"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8" v-if="$route.query.sendType ==='直发'">
          <el-form-item label="物流公司：" label-width="70px">
            <el-input v-model="params.logisticCompany"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="params.logisticType !== '供应商配送'">
          <el-form-item
            label="物流费用："
            v-if="$route.query.sendType === '入库'&&contractFrom==='直备采购'"
            label-width="70px"
          >
            <el-select v-model="params.expressFee">
              <el-option
                v-for="(item, index) in expressFeeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="物流费用："
            v-if="$route.query.sendType === '入库'&&contractFrom==='采购计划'"
            label-width="70px"
          >
            <el-select v-model="params.expressFee">
              <el-option
                v-for="(item, index) in expressFeeListPlan"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col
          :span="8"
          v-if="
            params.logisticType === '物流配送' ||
              params.logisticType === undefined
          "
        >
          <el-form-item label="物流单号：" label-width="70px">
            <el-input v-model="params.logisticNumber"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="
            params.logisticType === '快递配送'">
          <el-form-item label="快递单号：" label-width="70px">
            <el-input v-model="params.expressName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="params.logisticType === '供应商配送'">
          <el-form-item label="预计到达时间：" label-width="98px">
            <el-date-picker
              v-model="params.supplierDeliverDate"
              type="date"
              style="width:100%;"
              value-format="yyyy-MM-dd"
              :picker-options="timeChange"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { queryByState } from '@/api/sell/sellManage'

export default {
  props: ['contractFrom'],
  data () {
    return {
      timeChange: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7 // 选择时间范围
        }
      },
      expressCompanyList: [], // 物流公司
      logisticTypeList: [
        { label: '物流配送', value: '物流配送' },
        { label: '快递配送', value: '快递配送' },
        { label: '供应商配送', value: '供应商配送' }
      ],
      expressFeeList: [
        { label: '供应商承担', value: '供应商承担' },
        { label: '公司承担', value: '公司承担' }
      ],
      expressFeeListPlan: [
        { label: '供应商承担', value: '供应商承担' },
        { label: '提成结算', value: '提成结算' },
        { label: '公司承担', value: '公司承担' }
      ],
      params: {}
    }
  },
  methods: {
    logisticTypeChange (params) {
      this.params = {
        logisticType: params
      }
    }
  },
  mounted () {
    // 快递公司
    queryByState()
      .then((res) => {
        if (res.data.code === 200) {
          this.expressCompanyList = res.data.obj
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  watch: {
    params: {
      handler (newVal) {
        let params = {}
        if (
          newVal.logisticType === '物流配送' &&
          this.$route.query.sendType === '入库'
        ) {
          params = {
            logisticCompany: newVal.logisticCompany, // 物流公司
            logisticNumber: newVal.logisticNumber, // 物流单号
            logisticType: newVal.logisticType, // 配送方式
            expressFee: newVal.expressFee // 快递承运方式
          }
          this.$emit('purchaseDeliverLogisticVo', params)
        } else if (
          newVal.logisticType === '快递配送' &&
          this.$route.query.sendType === '入库'
        ) {
          params = {
            expressCompany: newVal.expressCompany, // 快递公司
            expressName: newVal.expressName, // 快递单号
            logisticType: newVal.logisticType, // 配送方式
            expressFee: newVal.expressFee // 快递承运方式
          }
          this.$emit('purchaseDeliverLogisticVo', params)
        } else if (newVal.logisticType === '供应商配送') {
          params = {
            logisticType: newVal.logisticType, // 配送方式
            supplierDeliverDate: newVal.supplierDeliverDate // 预计发货时间
          }
          this.$emit('purchaseDeliverLogisticVo', params)
        } else if (this.$route.query.sendType === '直发') {
          params = {
            logisticCompany: newVal.logisticCompany, // 物流公司
            logisticNumber: newVal.logisticNumber, // 物流单号
            logisticType: '物流配送' // 配送方式
          }
          this.$emit('purchaseDeliverLogisticVo', params)
        }
      },
      deep: true
    }
  }
}
</script>
